import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    descripcion: '',
    articuloTipoId: 0,
    articuloTipo: null,
    articuloTipoNombre: null,
    inactivo: false,
    rowVersion: null,
    
    articuloDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_ARTICULO'(state, articuloId) {
        state.id = articuloId;
        state.nombre = '';
        state.descripcion = '';
        state.articuloTipoId = 0;
        state.articuloTipo = null;
        state.articuloTipoNombre = null;
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_ARTICULO'(state, articulo) {
        state.nombre = articulo.nombre.toUpperCase().trim();
        state.descripcion = articulo.descripcion.toUpperCase().trim();
        state.articuloTipoId = articulo.articuloTipo? articulo.articuloTipo.id : 0;
        state.articuloTipo = articulo.articuloTipo;
        state.articuloTipoNombre = articulo.articuloTipo? articulo.articuloTipo.nombre.trim() : null;
        state.inactivo = articulo.inactivo;
        state.rowVersion = articulo.rowVersion;
    },
    'SET_ARTICULO_TIPO'(state, articuloTipo) {
        state.articuloTipo = articuloTipo;
        state.articuloTipoId = articuloTipo? articuloTipo.id : 0;
        state.articuloTipoNombre = articuloTipo? articuloTipo.nombre.trim() : null;
    },

    'SET_ARTICULO_ID' (state, articulo) {
        state.id = articulo.id;
        state.rowVersion = articulo.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.articuloDatos = [];
    },
    'SET_DATOS'(state, params) {
        state.articuloDatos = params.articuloDatos;
    },
};

const getters = {
    getField,

    articulo(state) {
        return {
            id: state.id,
            nombre: state.nombre.toUpperCase().trim(),
            descripcion: state.descripcion.toUpperCase().trim(),
            articuloTipoId: state.articuloTipoId,
            inactivo: state.inactivo,
            rowVersion: state.rowVersion,
        }
    }
};

const actions = {
    inicializar ( { commit }, articuloId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ARTICULO', articuloId);
            if (articuloId != 0){
                apiAxios.get('articulos/' + articuloId + '/abm' ) 
                    .then(res => {
                        commit('SET_ARTICULO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( {commit} ) {
        return new Promise((resolve, reject) => {
            let articulo= {
                nombre: state.nombre.toUpperCase().trim(),
                descripcion: state.descripcion.trim(),
                articuloTipoId: state.articuloTipoId,
                inactivo: state.inactivo,
                rowVersion: state.rowVersion,
            }
            let url = 'articulos';

            if (state.id != 0) {
                url += '/' + state.id;
            }

            apiAxios.post(url, articulo)
                .then((res) => {
                    /* Actualizamos Id y RowVersion */
                    commit('SET_ARTICULO_ID', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setArticuloTipo: ({commit}, articuloTipo) => {
        commit('SET_ARTICULO_TIPO', articuloTipo);
    },

    inactivar ( {}, articuloId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('articulos/' + articuloId + '/inactivar')
                .then(() => {
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getDatos ( { commit }, articuloId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (articuloId != 0) {
                apiAxios.get('articulos/' + articuloId) 
                    .then(res => {
                        let datos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'descripcion', 'campo': 'Descripcion', 'valor': res.data.descripcion, 'formato': '' },
                            { 'nombre': 'articuloTipo', 'campo': 'Tipo', 'valor': res.data.articuloTipo, 'formato': '' },
                            // { 'nombre': 'diasProduccion', 'campo': 'Dias Producción:', 'valor': res.data.diasProduccion, 'formato': '' },
                            // { 'nombre': 'unidades', 'campo': 'Unidades', 'valor': res.data.unidades, 'formato': '' },
                            { 'nombre': 'stock', 'campo': 'Stock', 'valor': res.data.stock, 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': res.data.inactivo? 'Si' : 'No', 'formato': '' },
                        ];
                        let params = {
                            articuloDatos: datos,
                        }
                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}